import { FeatureFlags } from "./LocalServerConstants";

export const BrokerConstants = {
    GuarantorInviteStatus: {
        PENDING: "Pending",
        NOTSEND: "Not Sent",
        ACCEPTED: "Accepted",
        DECLINED: "Declined",
        COMPLETED: "Completed",
    },
    InteriorCardTabs: {
        Tasks: {
            name: "Tasks",
            icon: "list ol"
        },
        Milestones: {
            name: "Timeline",
            icon: "trophy"
        },
        Pricing: {
            name: "Pricing",
            icon: "dollar"
        },
        Project: {
            name: "Project",
            icon: "list"
        },
        Properties: {
            name: "Properties",
            icon: "home"
        },
        Borrower: {
            name: "Borrower",
            icon: "address book"
        },
        Guarantors: {
            name: "Guarantors",
            icon: "group"
        },
        Documents: {
            name: "Documents",
            icon: "images"
        },
        Payments: {
            name: "Payments",
            icon: "credit card"
        },
        Comments: {
            name: "Comments",
            icon: "comment"
        }
    },
    InteriorCardAccordions: {
        PricingLoanSummary: {
            id: "9af9e600-dd0a-4d96-ac69-f40518116430",
            name: "Loan Summary"
        },
        PricingLoanDetails: {
            id: "af9542f2-70ed-43c6-b840-ebe2fbd4ea69",
            name: "Loan Details"
        },
        PricingProjectDetails: {
            id: "621c9840-9276-432a-842a-14a8a825f86a",
            name: "Project Details"
        },
        PricingProjectBreakdown: {
            id: "98b01e61-3e62-4279-9ab4-9bd0a17277cf",
            name: "Project Breakdown"
        },
        DetailsOverview: {
            id: "46c33d35-42ae-4754-8675-93efed0aff23",
            name: "Overview"
        },
        DetailsFinancials: {
            id: "49184021-b280-49c2-97af-1b442e4aa41a",
            name: "Financials"
        },
        DetailsSiteDevelopment: {
            id: "b07d6c26-7df0-496c-aba2-ce432f719285",
            name: "Site Development"
        },
        DetailsConstruction: {
            id: "bbdbad43-e685-4e70-9d88-f7deebc46f63",
            name: "Construction"
        },
        DetailsTerm: {
            id: "b1689955-2315-4415-a97a-77e5fa63b5df",
            name: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "Construction Completion Schedule and Loan Term" : "Construction Schedule"
        },
        BorrowerInformation: {
            id: "f337c056-9835-4934-96db-0ba797d6f81b",
            name: "Borrower Information"
        },
        BorrowerExperience: {
            id: "6c04c3d8-09dd-4215-a8a0-27508902e4a8",
            name: "Borrower Experience"
        },
        BorrowerAssets: {
            id: "11f0c238-ce76-4077-8fe1-eb30b652bb35",
            name: "Assets"
        },
        BorrowerLiabilities: {
            id: "b4bc776c-cc08-4943-8749-564280cbbeb9",
            name: "Liabilities"
        },
        BorrowerREO: {
            id: "047b0469-6bbe-448c-8416-3f9976e125bb",
            name: "Real Estate Owned"
        },
        Properties: {
            id: "047b0469-6bbe-448c-8416-3f9976e125bb",
            name: "Property"
        },
        CollateralProperties: {
            id: "c4c4f05b-650b-4da7-abf6-cf52f852d8c8",
            name: "Collateral Properties"
        },
        BuilderInfo: {
            id: "39cd8eea-2694-40ae-864b-e8711f2882a3",
            name: "Builder Information"
        },
    },
    InteriorCardGuarantorAccordions : {
        ContactInformation: "Contact Information",
        PersonalDetails: "Personal Details",
        CreditScore: "Credit Score",
        Assets: "Assets",
        Liabilities: "Liabilities",
        ReoSchedules: "Real Estate Owned Schedules",
        DisclosureStatuses: "Authorizations and Disclosures:",
    },
    SendToBrokerModalStates: {
        SendToBroker: "Send To Broker"
    },
    ALScheduleType: {
      ASSET: "asset",
      LIABILITY: "liability"
    },
    Builder: {
      BuilderIsBorrower: "4b7fac75-2b86-44c4-9a51-614e3ac0c6b2",
      BuilderIsNotBorrower: "c300f4af-faad-4866-b570-6bac952e39a2"
    },
    BorrowerApplicationStatusLookupName: {
      NEW: "New",
      SENT: "Sent",
      REVISION: "Revision",
      SUBMITTED: "Submitted"
    }
};

export const ConfigDefaults = {
    MIN_MANDATORY_BROKER_FEE: 0.5
};